import { Box, Container, Paper, Typography } from '@mui/material'
import { audience } from '../../data/landing'
import audienceBg from '../../assets/images/location.png'

export default function TargetAudience() {
  return (
    <Box component="section" sx={{ py: { xs: 8, md: 10 } }}>
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            position: 'relative',
            overflow: 'hidden',
            px: { xs: 3, sm: 4, md: 6 },
            py: { xs: 4, sm: 5, md: 6 },
            borderRadius: { xs: 4, md: 5 },
            backgroundImage: `url(${audienceBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff',
            isolation: 'isolate',
          }}
        >
          <Box
            aria-hidden="true"
            sx={{
              position: 'absolute',
              inset: 0,
              background: `
                linear-gradient(
                  135deg,
                  rgba(0,0,0,0.82) 0%,
                  rgba(0,0,0,0.62) 45%,
                  rgba(0,0,0,0.52) 100%
                )
              `,
              zIndex: -1,
            }}
          />

          <Box sx={{ maxWidth: 820, mb: { xs: 4, md: 5 } }}>
            <Typography
              variant="overline"
              sx={{
                display: 'block',
                letterSpacing: '0.12em',
                color: 'rgba(255,255,255,0.65)',
                mb: 1,
              }}
            >
              Who this is for
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                lineHeight: 1.2,
                fontSize: { xs: '2rem', sm: '2.4rem', md: '3rem' },
                mb: 2,
              }}
            >
              Perfect for locations with traffic and dwell time
            </Typography>

            <Typography
              sx={{
                color: 'rgba(255,255,255,0.82)',
                fontSize: { xs: '1rem', md: '1.05rem' },
                lineHeight: 1.8,
              }}
            >
              Our self-service kiosks work best in places where people wait, gather,
              or spend time on-site. That existing traffic becomes an opportunity for
              added convenience and new revenue.
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))',
              },
              gap: 3,
              listStyle: 'none',
              p: 0,
              m: 0,
            }}
          >
            {audience.map((item) => (
              <Box component="li" key={item} sx={{ display: 'flex' }}>
                <Paper
                  elevation={0}
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 1.75,
                    width: '100%',
                    height: '100%',
                    p: 3,
                    borderRadius: 4,
                    backgroundColor: 'rgba(255,255,255,0.08)',
                    backdropFilter: 'blur(10px)',
                    WebkitBackdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: '#fff',
                    transition: 'transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.22)',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      borderColor: 'rgba(255,255,255,0.22)',
                      boxShadow: '0 16px 40px rgba(0,0,0,0.32)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      bgcolor: '#4caf50',
                      mt: '0.55rem',
                      flexShrink: 0,
                      boxShadow: '0 0 0 4px rgba(76, 175, 80, 0.18)',
                    }}
                  />

                  <Typography
                    sx={{
                      color: 'rgba(255,255,255,0.92)',
                      lineHeight: 1.7,
                      fontSize: '0.98rem',
                    }}
                  >
                    {item}
                  </Typography>
                </Paper>
              </Box>
            ))}
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}